var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAxur(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5425 18.5806C25.5777 18.5154 25.6458 18.4747 25.7199 18.4747L28.0559 18.4746C28.2081 18.4746 28.3055 18.6369 28.2338 18.7712L22.55 29.4169C22.515 29.4825 22.4466 29.5235 22.3722 29.5235L19.9755 29.5236C19.8228 29.5236 19.7256 29.3606 19.798 29.2263L25.5425 18.5806Z",
    fill: "#FF5824"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2847 18.5806C31.3199 18.5154 31.388 18.4747 31.4621 18.4747L33.7981 18.4746C33.9503 18.4746 34.0477 18.6369 33.976 18.7712L28.2922 29.4169C28.2572 29.4825 28.1888 29.5235 28.1144 29.5235L25.7177 29.5236C25.565 29.5236 25.4678 29.3606 25.5402 29.2263L31.2847 18.5806Z",
    fill: "#FF5824"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.769 18.5806C19.8041 18.5154 19.8723 18.4747 19.9464 18.4747L22.2823 18.4746C22.4346 18.4746 22.5319 18.6369 22.4602 18.7712L16.7764 29.4169C16.7414 29.4825 16.673 29.5235 16.5986 29.5235L14.2019 29.5236C14.0493 29.5236 13.952 29.3606 14.0245 29.2263L19.769 18.5806Z",
    fill: "#FF5824"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAxur);
export default __webpack_public_path__ + "static/media/Axur.721f7f867fdd47534c47f9a232d258f4.svg";
export { ForwardRef as ReactComponent };